import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import PureCounter from '@srexi/purecounterjs';
import aboutImg from '../img/about/about-21.webp';
import heroImg from '../img/hero.jpg';
import heroImg1 from '../img/hero2.jpg';

function Hero() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    new PureCounter();
    }, []);
  return (
    <section id="hero" className="hero section dark-background">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6" data-aos="fade-right" data-aos-delay="200">
              <div className="hero-content">
                <h3> POWERXONE ENGINEERING SOLUTION</h3>
                <p>
                  We provides cutting-edge power distribution and control systems for industrial, 
                  commercial, and infrastructure sectors. All our products meet BSTI, IEC, and 
                  international safety standards to ensure performance, reliability, and safety.

                </p>
                <div className="hero-btns">
                  <a href="#consultation" className="btn btn-primary">
                    Get a Free Consultation
                  </a>
                  <a href="#services" className="btn btn-outline">
                    Our Services
                  </a>
                </div>
                <div className="hero-stats">
                  <div className="stat-item">
                    <h3>
                      <span
                        data-purecounter-start="0"
                        data-purecounter-end="15"
                        data-purecounter-duration="1"
                        className="purecounter"
                      ></span>
                      +
                    </h3>
                    <p>Years Experience</p>
                  </div>
                  <div className="stat-item">
                    <h3>
                      <span
                        data-purecounter-start="0"
                        data-purecounter-end="500"
                        data-purecounter-duration="1"
                        className="purecounter"
                      ></span>
                      +
                    </h3>
                    <p>Clients Worldwide</p>
                  </div>
                  <div className="stat-item">
                    <h3>
                      <span
                        data-purecounter-start="0"
                        data-purecounter-end="98"
                        data-purecounter-duration="1"
                        className="purecounter"
                      ></span>
                      %
                    </h3>
                    <p>Success Rate</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6" data-aos="zoom-in" data-aos-delay="300">
              <div className="hero-image">
                <img src={heroImg1} alt="Consulting Services" style={{ height: '400px' }} className="img-fluid" />

              </div>
            </div>
          </div>
        </div>
      </section>
  )
}

export default Hero